/** @format */

import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Unauthorized from 'common/UnAuthorized';
import Spinner from 'common/LoadingIndecator';
import storage from 'infrastructure/utils/storage';

const MainLayout = React.lazy(() => import('common/Layout'));

type Props = {
  component: React.LazyExoticComponent<() => JSX.Element> | any;
  path: string | string[];
  exact: boolean;
  requestedRole: Array<string | null | undefined>;
  name: string;
};

const Protected = ({
  component: Component,
  path,
  exact,
  name,
  requestedRole = [],
  ...rest
}: Props) => {
  const isAuthed = !!storage.getItem('access_token');
  const role = (storage.getItem('role') || '').toLowerCase();

  const authorized = requestedRole.some((val) => {
    if (!val) return false;
    return role.includes(val.toLowerCase());
  });

  const AuthenticatedAndAuthorized = (props: any) => {
    return (
      <Suspense fallback={<Spinner size='large' />}>
        {name === 'CreateAdmin' ||
        name === 'EditAdmin' ||
        name === 'CreatePage' ||
        name === 'EditPage' ||
        name === 'CompaniesDetails' ||
        name === 'ShoppersDetails' ||
        name === 'EvaluationTemplatesDetails' ||
        name === 'CreateEvaluationTemplate' ||
        name === 'EditEvaluationTemplates' ||
        name === 'DiscountForm' ||
        name === 'JobsDetails' ||
        name === 'EditSummary' ? (
          <Component {...rest} {...props} />
        ) : (
          <MainLayout>
            <Component {...rest} {...props} />
          </MainLayout>
        )}
      </Suspense>
    );
  };

  if (!isAuthed) {
    return (
      <Route
        {...rest}
        render={() => {
          return <Redirect to='/login' />;
        }}
      />
    );
  }

  return !authorized ? (
    <Route
      {...rest}
      render={() => {
        return <Unauthorized />;
      }}
    />
  ) : (
    <Route
      {...rest}
      render={(props) => {
        return <AuthenticatedAndAuthorized props={props} />;
      }}
    />
  );
};
export default Protected;
